var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 73C56.8823 73 73 56.8823 73 37C73 17.1178 56.8823 1 37 1C17.1178 1 1 17.1178 1 37C1 56.8823 17.1178 73 37 73Z",
    fill: "#006D77",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 29.7317C30.4229 29.7317 31.7893 28.3653 31.7893 26.6798C31.7893 24.9943 30.4229 23.6279 28.7374 23.6279C27.0519 23.6279 25.6855 24.9943 25.6855 26.6798C25.6855 28.3653 27.0519 29.7317 28.7374 29.7317Z",
    fill: "#83C5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2806 31.77H26.1942C25.9134 31.77 25.6855 31.9979 25.6855 32.2787V47.538C25.6855 47.8188 25.9134 48.0467 26.1942 48.0467H31.2806C31.5614 48.0467 31.7893 47.8188 31.7893 47.538V32.2787C31.7893 31.9979 31.5614 31.77 31.2806 31.77Z",
    fill: "#83C5BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4385 30.9239C44.2646 30.1792 41.5453 30.8333 39.9146 32.0063C39.8587 31.7875 39.6593 31.6248 39.4223 31.6248H34.3358C34.055 31.6248 33.8271 31.8526 33.8271 32.1334V47.3928C33.8271 47.6736 34.055 47.9014 34.3358 47.9014H39.4223C39.703 47.9014 39.9309 47.6736 39.9309 47.3928V36.4264C40.7529 35.7184 41.8119 35.4925 42.6786 35.8608C43.5189 36.2158 44.0001 37.0825 44.0001 38.2372V47.3928C44.0001 47.6736 44.2279 47.9014 44.5087 47.9014H49.5952C49.8759 47.9014 50.1038 47.6736 50.1038 47.3928V37.2128C50.0458 33.0327 48.0794 31.4854 46.4385 30.9239Z",
    fill: "#83C5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.fae4c1c5093ba10d92ed8b7e129b2351.svg";
export { ForwardRef as ReactComponent };